import { Game, ImageType } from "@blacknut/javascript-sdk/dist";
import styles from "./styles.module.scss";

const GameBackground = ({ game }: { game: Game }) => {
  const backgroundImage =
    game && game.images && game.images.find((im) => im.type === ImageType.BACKGROUND);

  return (
    <>
      <img className={styles.backgroundImage} src={backgroundImage?.url}></img>
      <div className={styles.mask} />
    </>
  );
};
export default GameBackground;
